import type { Locale } from "@/5-shared/types/common";

/**
 * The active UI locale, mirrored here by I18nProvider in render, for the code that
 * reads it outside React: the API client's `Accept-Language` and Zod's messages
 * (`types/zodSetup`). It imports neither axios nor zod, so the provider can set it on
 * every page while those libraries load only with the pages that use them.
 */
let active: Locale = "it";

export function setActiveLocale(locale: Locale): void {
  active = locale;
}

export function activeLocale(): Locale {
  return active;
}
